import { useState } from "react";
import { Crown, Gem } from "lucide-react";
import { VIP_BY_TIER } from "@/lib/vipTiers";

const SIZES = { xs: "w-5 h-5", sm: "w-8 h-8", md: "w-16 h-16", lg: "w-24 h-24", xl: "w-40 h-40" };
const ICON = { xs: 10, sm: 14, md: 26, lg: 40, xl: 64 };

// Official MyPandaX tier badge artwork (transparent PNG, /vip-art/tier_{tier}.png); gradient-ring fallback if the file is missing.
export default function VipMedallion({ tier, size = "md", className = "", src }) {
  const [failed, setFailed] = useState(false);
  const t = VIP_BY_TIER[tier];
  if (!t) return null;
  const Icon = tier === "boss" ? Crown : Gem;
  return (
    <span
      data-testid={`vip-medallion-${tier}`}
      className={`relative inline-grid place-items-center ${failed ? `rounded-full overflow-hidden bg-gradient-to-br ${t.ring} shadow-lg ${t.glow}` : ""} ${SIZES[size]} ${className}`}
      title={t.label}
    >
      {failed ? (
        <>
          <span className="absolute inset-[3px] rounded-full bg-zinc-950/90" />
          <Icon size={ICON[size]} className={`relative ${t.text}`} strokeWidth={1.6} />
        </>
      ) : (
        <img src={src || `/vip-art/tier_${tier}.png`} alt={t.label} onError={() => setFailed(true)} className={`absolute inset-0 w-full h-full object-contain drop-shadow-[0_2px_8px_rgba(0,0,0,0.6)]`} draggable={false} />
      )}
    </span>
  );
}
